module.exports = __webpack_public_path__ + "static/media/industry-partners-second.bfe29a00.jpg";